import { createApiSlice } from "@common";
import {
    MY_INFO_ADDRESS,
} from "@routes";

// Define the API config array
const apiConfig = [
    {
        name: "addMyInfoAddress",
        method: "post",
        url: MY_INFO_ADDRESS,
        stateKey: "message",
    },
    {
        name: "getMyInfoAddress",
        method: "get",
        url: MY_INFO_ADDRESS,
        stateKey: "data",
    },
    {
        name: "updateMyInfoAddress",
        method: "put",
        url: MY_INFO_ADDRESS,
        stateKey: "message",
    },
    {
        name: "deleteMyInfoAddress",
        method: "delete",
        url: MY_INFO_ADDRESS,
        stateKey: "message",
    },
];

// Define custom reducers and their initial state
const customReducers = {
    initialState: {
        data: [],
        additionalData: [],
    },
    reducers: {
        setAdditionalData: (state, action) => {
            state.additionalData = action.payload;
        },
    },
    extraReducers: {
        // Example of custom extra reducer
        someCustomAction: (state, action) => {
            // Custom reducer logic
        },
    },
};

// Generate the slice, thunks, and actions using the utility function
const { slice, thunks, actions } = createApiSlice(
    "MyInfoAddress",
    apiConfig,
    customReducers,
);
const MyInfoAddressSlice = slice;
// Export the slice's reducer
export default MyInfoAddressSlice.reducer;

// Destructure and export thunks directly from thunksExports
export const {
    addMyInfoAddress,
    getMyInfoAddress,
    updateMyInfoAddress,
    deleteMyInfoAddress
} = thunks;

// Destructure and export actions directly from actionsExports
export const { rowSelect } =
    actions;
